import http from "@/utils/http";


export const MessagePushAdminApi = {

    getMessagePushAdminListByCurrentCompany() {
        return http.get(`/messagePushAdmin/getMessagePushAdminListByCurrentCompany`)
    },
    addMessagePushAdmin(data) {
        return http.post(`/messagePushAdmin/addMessagePushAdmin`,data)
    },
    deleteMessagePushAdmin(userId) {
        return http.get(`/messagePushAdmin/deleteMessagePushAdmin/${userId}`)
    },
}